<template>
  <div id="header">
    <div class="content header-global">
      <ul class="left">
        <li @click="handleHeaderTabClick('/')">
          <img
            src="https://image.kilimall.com/seller/kili_logo.png"
            alt="perfeelogo"
            class="logo"
          >
        </li>
        <li v-if="/create-seller-account/.test($route.path)">
          <a
            :href="
              $store.state.locale === 'en'
                ? 'https://www.kilimall.co.ke/help-center/oh_3625?c_id=1149&s_id=1006&bs_type=2'
                : 'https://www.kilimall.co.ke/help-center/oh_3597?c_id=1119&s_id=1003&bs_type=2'
            "
            target="_blank"
          >{{ $t('nav.helpCenter') }}</a>
        </li>
        <!-- TODO 暂不展示【招商政策、平台介绍、卖家APP】功能入口 -->
        <!-- <li v-show="curLocale === 'zh'">
          <a
            class="jump-btn"
            :href="$domain()+'/introduce'"
            target="_blank"
          >
            {{ $t('nav.introduce') }}
          </a>
        </li>
        <li v-show="curLocale === 'zh'">
          <a
            class="jump-btn"
            :href="$domain()+'/seller-rules'"
            target="_blank"
          >
            {{ $t('nav.policy') }}
          </a>
        </li> -->
      </ul>
      <ul class="right">
        <!-- 语言切换 -->
        <li class="language">
          <LocalSet />
        </li>
        <!-- 成为卖家 -->
        <li
          v-if="!$store.state.isLogin"
          @click="handleHeaderTabClick('/create-seller-account/entry')"
        >
          <span>
            {{ $t('nav.openMerchants') }}
          </span>
        </li>
        <!-- 未登录 -->
        <li
          v-if="!$store.state.isLogin"
          @click="handleHeaderTabClick('/login')"
        >
          {{ $t('nav.login') }}
        </li>
        <!-- 已登录 -->
        <li
          v-if="$store.state.isLogin"
          class="userName tc"
        >
          <img
            class="userIcon"
            src="~/assets/img/header/user.png"
            alt="user"
          >
          {{ $store.state.userName }}
          <ul>
            <li @click="toAdmin">
              {{ $t('nav.sellerCenter') }}
            </li>
            <li @click="logOut">
              {{ $t('nav.logOut') }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import LocalSet from './localDropdown.vue'
import { storeApplyInfo, getSellerInfo } from '_h/account'
export default {
  name: 'MyHeader',
  components: { LocalSet },
  props: {
    localeList: {
      type: Array,
      default: () => ([])
    },
    curLocale: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      oldSellerUrl: ''
    }
  },
  mounted() {
    this.csrOperation()
  },
  updated() {
    this.csrOperation()
  },
  methods: {
    handleHeaderTabClick(path) {
      this.$router.push({ path })
    },
    handleUpdateI18nClick(e) {
      this.$emit('i18n:update', e)
    },
    toChinese() {
      const reg = /^\/zh/
      let path
      reg.test(this.$route.fullPath)
        ? (path = this.$route.fullPath)
        : (path = `/zh${this.$route.fullPath}`)
      return path
    },
    toEnglish() {
      return this.$route.fullPath.replace(/^\/zh/, '')
    },
    csrOperation() {
      if (this.$cookies.get('user-id')) {
        this.$store.commit('setIsLogin')
        this.$store.commit('setUserName', this.$cookies.get('user-account'))
      }
    },
    toAdmin() {
      if (this.$cookies.get('has-store')) {
        this.$router.push('/seller-center/home')
      } else {
        this.getSellerInfoData()
      }
    },
    logOut() {
      this.$store.commit('logOut')
      this.$ClearAllCookieFn()
      this.$router.replace('/')
    },
    async getSellerInfoData() {
      try {
        const res = await getSellerInfo(this.$axios)
        const { basicInfo, settlementInfo } = res.sellerInfo
        if (!basicInfo.idNumber) {
          // 只是注册了,未填写资质信息
          this.$router.push({
            path: '/create-seller-account/step2'
          })
          return
        }
        if (!settlementInfo.bankName && !settlementInfo.skipSettlementInfo) {
          // 未填写结算信息
          this.$router.push({
            path: '/create-seller-account/step3'
          })
          return
        }
        // 是否提交过创建店铺的申请 申请过跳到开店审核步骤,反之到开店步骤
        this.$axios
          .request(storeApplyInfo({
            sellerId: this.$cookies.get('seller-id')
          }))
          .then((res) => {
            if (Number(res.data.code) === 0) {
              const stepPath = res.data.data.length ? '/create-seller-account/step5' : '/create-seller-account/step4?default=1'
              this.$router.push(stepPath)
            }
          })
      } catch (error) {
        console.error(error)
        this.$handleError(this, error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#header {
  background-color: #fff;
  // min-width: 1366px;
  font-size: 16px;
  // height: 82px;
  .content {
    display: flex;
    justify-content: space-between;
    & > ul {
      position: relative;
      height: $navHeight;
      line-height: $navHeight;
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > li {
        margin-left: 0.3rem;
        position: relative;
        @extend .cr;
        &:first-child {
          margin-left: 0;
        }
      }
      .userIcon {
        width: 0.16rem;
        height: 0.18rem;
        position: relative;
        top: 0.02rem;
      }
    }
    .to-old-seller-center {
      margin-right: 15px;
      cursor: pointer;
      color: #00b4ff;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .logo {
    height: 50px;
    vertical-align: middle;
    @extend .cr;
  }

  .language,
  .userName {
    position: relative;
    &:hover {
      ul {
        display: block;
      }
    }
    ul {
      display: none;
      padding: 10px 0;
      position: absolute;
      top: 80%;
      right: -15px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-bottom-color: #ccc;
      font-size: 0.14rem;
      border-radius: 0.04rem;
      white-space: nowrap;
      line-height: normal;
      text-align: left;
      li {
        line-height: 1.8em;
        padding: 0 24px 0 20px;
        color: #354c63;
        cursor: pointer;

        &:hover {
          color: $red;
        }
      }
    }
  }
  .openMerchants {
    color: $red;
    text-decoration: underline;
  }
}
.jump-btn{
  color: #515a6e;
}
</style>
